import { useEffect } from 'react';
import { Row, Col, Card } from 'reactstrap';
import useDashboard from './useDashboard';
import { useSelector } from 'react-redux';
import HighlightsCard from './DashboardCards/HighlightsCard';
import ProductsLocationsCard from './DashboardCards/ProductsLocationsCard';
import DashboardChartsCard from './DashboardCards/DashboardChartsCard';
import BEPDistributorListCard from './DashboardCards/BEPDistributorListCard';
import SlideDrawer from '../../sharedComponents/SlideDrawer/SlideDrawer';
import getWelcomeName from '../../sharedComponents/WelcomeName/getWelcomeName';
import { BsFillGridFill } from 'react-icons/bs';
import PageHeader from '../../sharedComponents/Header/PageHeader';
import SegmentOverviewCard from './DashboardCards/SegmentOverviewCard';
import ManufacturerSelect from "../../sharedComponents/ManufacturerSelect/ManufacturerSelect";
import FiltersWidget from '../../sharedComponents/Filters/FiltersWidget';
import { filtersDateRanges } from '../../config/constants';
import MobileMenuSlideDrawer from '../../sharedComponents/SlideDrawer/MobileMenuSlideDrawer';

const Dashboard = () => {
  const {
    fromDate, toDate, onApplySearch
  } = useDashboard.useDates();
  const { setDashboardTab } = useDashboard.useDashboard();
  const minDate = useSelector(({dates}) => dates.dashMinDate);
  const slideDrawerContents = useSelector(({dashboard}) => dashboard.slideDrawer);
  var mfrName = getWelcomeName() || 'Admin';
  const selectedManufacturers = useSelector(({user}) => user.selectedManufacturers);  

  // eslint-disable-next-line
  useEffect(() => {setDashboardTab();}, []);

  //eslint-disable-next-line
  useEffect(() => onApplySearch(), [selectedManufacturers]);

  return (
    <>
      <PageHeader title='Dashboard' subtitle="Today's Highlights" icon={<BsFillGridFill fill='url(#icon-gradient)'/>}/>
      <Col className='p-3'>
        <Row className='label-text text-size-14 d-flex align-items-center mx-auto pb-2'>
          <Col className='ps-0'>
            <div className='main-header text-size-20' style={{lineHeight:'23px', fontWeight:'700',letterSpacing:'.0025em' }}>Today's Highlights</div>
          </Col>
          <Col className='col-auto ps-0 pe-0'>
            <Row>
              <Col>
                <ManufacturerSelect />
              </Col>
            </Row>
          </Col>
        </Row>
        <Row xs={1} md={1} lg={1} xl={1} className='label-text text-size-14 d-flex align-items-center card-row g-2'>
          <Card className='dashboard-card px-3' style={{height: 'initial'}}>
            <HighlightsCard />
          </Card>
          <FiltersWidget 
            minDate={minDate} 
            dateRanges={filtersDateRanges}
            fromDate={fromDate}
            toDate={toDate}
            onApplyFilters={onApplySearch}
            saveFilterSetsEnabled={true}
            filterSetOptionsEnabled={true}
          />
          <Card className='products-locations-card px-3'>
            <ProductsLocationsCard />
          </Card>
          <Card className='dashboard-card px-3 py-1' style={{minHeight: '750px', height: '100%'}}>
            <DashboardChartsCard />
          </Card>
          <Card className='dashboard-card px-3' style={{minHeight: '450px'}}>
            <BEPDistributorListCard />
          </Card>
          <Card className='dashboard-card px-3' style={{minHeight: '450px'}}>
            <SegmentOverviewCard />
          </Card>
        </Row>
        <Row>
          <Col className=' w-fc ms-auto me-0'>
            <div className='text-beplBlue' style={{'display': (mfrName ? 'block' : 'none')}}>*All data is for {mfrName}</div>
          </Col>
        </Row>
        <SlideDrawer title={slideDrawerContents.title} drawerContents={slideDrawerContents.contents}/>
        <MobileMenuSlideDrawer />
      </Col>
    </>
  );
}

export default Dashboard;
